import styled from 'styled-components';
import Imgix from 'shared/components/imgix';
import { ReorderButton as _ReorderButton } from '../../../shared-styles';

export const ReorderButton = styled(_ReorderButton)`
  padding: 8px 20px;
`;

export const Row = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[95]};
  }
`;

export const TopLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OrderInfo = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[40]};
  line-height: 1.4;
`;

export const TotalCost = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grey[30]};
`;

export const BottomLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Thumbnails = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Thumbnail = styled(Imgix)`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const MoreBadge = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey[95]};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.grey[40]};
  display: flex;
  flex-direction: column;
  font-size: 11px;
  height: 48px;
  justify-content: center;
  line-height: 1;
  text-align: center;
  width: 48px;
`;
